import { Context } from "@nuxt/types/app";
import { isFinite } from "lodash-es";

interface MbFromBytePlugin {
  getMBFromBytes(number: number): number;
}

export default function (context: Context): MbFromBytePlugin {
  function getMBFromBytes(number: number): number {
    if (!isFinite(number)) {
      return 0;
    }

    return number / (1024 * 1024);
  }

  return { getMBFromBytes };
}
